import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const vmaConfig = {
  apiKey: "AIzaSyAs_KzV1efHYHjdiBKO1UDVhQFqj6Ui3UY",
  authDomain: "lma-value-my-aircraft.firebaseapp.com",
  projectId: "lma-value-my-aircraft",
  storageBucket: "lma-value-my-aircraft.firebasestorage.app",
  messagingSenderId: "170633165758",
  appId: "1:170633165758:web:53d39cca3919097c6e57ef",
};

const vmaApp = initializeApp(vmaConfig, "vma");
export const vmaDb = getFirestore(vmaApp);
export const vmaStorage = getStorage(vmaApp);
